export const images = [
  { id: 0, image: "", desc: "" },
  {
    id: 1,
    desc: "Rocky Shore",
    image: "https://images.pexels.com/photos/2049422/pexels-photo-2049422.jpeg",
  },
  {
    id: 2,
    desc: "Purple Bubbles",
    image: "https://images.pexels.com/photos/4194857/pexels-photo-4194857.jpeg",
  },
  {
    id: 3,
    desc: "Colorful Multicolor",
    image: "https://images.pexels.com/photos/6985045/pexels-photo-6985045.jpeg",
  },
  {
    id: 4,
    desc: "Plant Green Nature",
    image: "https://images.pexels.com/photos/4207779/pexels-photo-4207779.jpeg",
  },
  {
    id: 5,
    desc: "Geometry Shapes Simple",
    image: "https://images.pexels.com/photos/6070384/pexels-photo-6070384.jpeg",
  },
  {
    id: 6,
    desc: "Computer Simple",
    image: "https://images.pexels.com/photos/8534457/pexels-photo-8534457.jpeg",
  },
  {
    id: 7,
    desc: "Flowers Pink Aesthetic",
    image: "https://images.pexels.com/photos/4041280/pexels-photo-4041280.jpeg",
  },
  {
    id: 8,
    desc: "Couch Homey",
    image: "https://images.pexels.com/photos/6058444/pexels-photo-6058444.jpeg",
  },
  {
    id: 9,
    desc: "Gaming Chair PC Setup Computer",
    image: "https://images.pexels.com/photos/7858743/pexels-photo-7858743.jpeg",
  },
  {
    id: 10,
    desc: "Sky Skyscrapers buildings sky",
    image: "https://images.pexels.com/photos/1768073/pexels-photo-1768073.jpeg",
  },
];
